import type { ThemeV3 } from '../types/themeTypes';

export const rainTheme: ThemeV3 = {
  id: 'Rain',
  name: 'Rain',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': 'oklch(12.33% 0.0822 210)',
    'surface-1':
      'color-mix(in srgb, var(--color-surface-0) 65%, var(--color-surface-4))',
    'surface-2':
      'color-mix(in srgb, var(--color-surface-0) 42%, var(--color-surface-4))',
    'surface-3':
      'color-mix(in srgb, var(--color-surface-0) 21%, var(--color-surface-4))',
    'surface-4': 'oklch(27.57% 0.0256 210)',
    'content-0': 'oklch(94.35% 0.0205 210)',
    'content-1':
      'color-mix(in srgb, var(--color-content-0) 76%, var(--color-content-4))',
    'content-2':
      'color-mix(in srgb, var(--color-content-0) 51%, var(--color-content-4))',
    'content-3': 'oklch(0.64 0.008 210deg)',
    'content-4': 'oklch(38.98% 0.0114 210)',
    edge: 'oklch(30.89% 0.1632 210)',
    'edge-muted': 'oklch(33.42% 0.0201 210)',
    accent: 'oklch(86.93% 0.1683 200)',
    red: 'oklch(0.72 0.13 25.331deg)',
    orange: 'oklch(0.72 0.13 47.604deg)',
    amber: 'oklch(0.72 0.13 70.08deg)',
    yellow: 'oklch(0.72 0.13 86.047deg)',
    lime: 'oklch(0.72 0.13 130.85deg)',
    green: 'oklch(0.72 0.13 149.579deg)',
    teal: 'oklch(0.72 0.13 182.503deg)',
    cyan: 'oklch(0.72 0.13 215.221deg)',
    blue: 'oklch(0.72 0.13 259.815deg)',
    violet: 'oklch(0.72 0.13 292.717deg)',
    purple: 'oklch(0.72 0.13 303.9deg)',
    pink: 'oklch(0.72 0.13 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    lift: 'var(--layer-lift)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'oklch(71.06% 0.3078 200)',
    'link-hover': 'oklch(89.63% 0.105 200)',
    'link-visited': 'oklch(72% 0.13 261)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-lift)',
    message: 'var(--color-lift)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    chrome: 'var(--color-surface-4)',
  },
};
